import { useDynamicConfig } from '@statsig/react-bindings';

import DexcomHero from './_heros/DexcomHero';
import GiveUsTheFingerHero from './_heros/GiveUsTheFingerHero';
import OR4CeramicHero from './_heros/OR4CeramicHero';
import OR4Hero from './_heros/OR4Hero';
import PrimeHero from './_heros/PrimeHero';
import SinglesDay from './_heros/SinglesDay';

const heroLookup: Record<string, () => React.JSX.Element> = {
  DexcomHero,
  GiveUsTheFingerHero,
  OR4Hero,
  OR4CeramicHero,
  PrimeHero,
  SinglesDay,
};

type HeroType =
  | 'DexcomHero'
  | 'GiveUsTheFingerHero'
  | 'OR4Hero'
  | 'OR4CeramicHero'
  | 'PrimeHero'
  | 'SinglesDay';

// If statsig misbehaves we will fallback to this
const FallbackHero = OR4Hero;

const HomeHeroGate = () => {
  const configHero = useDynamicConfig('home_hero').get(
    'hero',
    'OR4Hero',
  ) as HeroType;

  const Hero = heroLookup[configHero];

  return Hero ? <Hero /> : <FallbackHero />;
};

export default HomeHeroGate;
